// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { geoExtent_abstract } from './../abstract/SagaBase/geoExtent_abstract';
export class geoExtent extends geoExtent_abstract {}
